import { combineReducers } from 'redux'
import {
  createReducer,
  createRequestReducer
} from 'pobble-components/dist/redux-helpers'
import { normalize, schema } from 'normalizr'

const normalizeChildren = data => {
  const child = new schema.Entity(
    'children',
    {},
    { idAttribute: child => child.student_type.account.id }
  )
  return normalize(data, [child])
}

const ChildrenReducer = combineReducers({
  fetchChildrenRequest: createRequestReducer('CHILDREN:FETCHING'),
  children: createReducer(null, {
    'CHILDREN:FETCHING_REQUEST_SUCCESS': (state, { response }) =>
      normalizeChildren(response.data.account.parent_types),
    'CHILDREN:APPROVE_REQUEST_SUCCESS': (state, { response, params }) => {
      return {
        ...state,
        entities: {
          children: {
            ...state.entities.children,
            [params.id]: {
              ...state.entities.children[params.id],
              permission: 'approved'
            }
          }
        }
      }
    },
    'CHILDREN:DECLINE_REQUEST_SUCCESS': (state, { response, params }) => {
      return {
        ...state,
        entities: {
          children: {
            ...state.entities.children,
            [params.id]: {
              ...state.entities.children[params.id],
              permission: 'disapproved'
            }
          }
        }
      }
    },
    'CHILDREN:REMOVE_REQUEST_SUCCESS': (state, { response, params }) => {
      return {
        ...state,
        result: state.result.filter(id => id !== params.studentId)
      }
    },
    'CHILDREN:CONNECT_STUDENT_REQUEST_SUCCESS': (state, { response }) => ({
      ...state,
      result: [...state.result, response.data.student.id],
      entities: {
        children: {
          ...state.entities.children,
          [response.data.student.id]: {
            student_type: {
              account: response.data.student
            }
          }
        }
      }
    })
  })
})

export default ChildrenReducer
